import { render } from "./voteCourItem.vue?vue&type=template&id=10b89b1c"
import script from "./voteCourItem.vue?vue&type=script&lang=js"
export * from "./voteCourItem.vue?vue&type=script&lang=js"

import "./voteCourItem.vue?vue&type=style&index=0&id=10b89b1c&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__